var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer mt-5 hds-footer",style:(_vm.footerBgStyle)},[_c('div',{staticClass:"footer-content"},[_c('div',{staticClass:"footer-links"},_vm._l((_vm.footer.items),function(item){return _c('a',{key:item.url,attrs:{"href":item.url}},[_vm._v(_vm._s(item.title))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }